module.exports = __webpack_public_path__ + "img/2.decbb7a9.jpg";